import { Button, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { Spinner } from '../../components/loading/Spinner';
import { ModalTitle } from '../../components/text/Titles';
import { useAllDatasets } from '../../lib/hooks';
import { DatasetSelection } from '../../types';
import { ClientScoring } from '../../types/result';
import { DatasetRow } from './DatasetRow';

type Props = {
  visible: boolean;
  onClose: () => any;
  clientAlgorithm: ClientScoring;
  scoringIdLookup: { algorithmDataset: string; id: string }[];
};

export const DatasetSettingsModal = ({ visible, onClose, clientAlgorithm, scoringIdLookup }: Props) => {
  const { datasets, loading } = useAllDatasets();
  const [datasetSelections, setDatasetSelections] = useState<DatasetSelection[]>([]);

  useEffect(() => {
    if (datasets) {
      const datasetSelects = datasets.map(dataset => {
        return {
          dataset: dataset,
          selected: clientAlgorithm.datasets.indexOf(dataset.id) >= 0,
          datasetToAlgorithmOverviewId: Number(
            scoringIdLookup.find(look => look.algorithmDataset === clientAlgorithm.algorithm_id + '_' + dataset.id)?.id
          ),
        } as DatasetSelection;
      });
      setDatasetSelections(datasetSelects);
    }
  }, [clientAlgorithm.algorithm_id, clientAlgorithm.datasets, clientAlgorithm.id, datasets, scoringIdLookup]);

  return (
    <Modal
      title={<ModalTitle>Add/remove datasets</ModalTitle>}
      visible={visible}
      onCancel={onClose}
      footer={
        <>
          <Button onClick={onClose}>Close</Button>
        </>
      }
      bodyStyle={{ paddingTop: 12 }}>
      <div className="overflow-scroll pr-3" style={{ height: '58vh' }}>
        {loading && <Spinner />}
        {!loading &&
          datasetSelections &&
          datasetSelections.map(datasetSelection => (
            <DatasetRow
              key={datasetSelection.datasetToAlgorithmOverviewId}
              datasetSelection={datasetSelection}
              algorithmId={clientAlgorithm.algorithm_id}
            />
          ))}
      </div>
    </Modal>
  );
};
